/**
 * Validazione configurazione
 */

/**
 * Valida URL
 * @param {string} url - URL da validare
 * @returns {boolean} True se valido
 */
export function isValidUrl(url) {
  if (!url) return false;
  try {
    new URL(url);
    return true;
  } catch {
    // Potrebbe essere un percorso relativo valido
    return typeof url === 'string' && url.length > 0;
  }
}

/**
 * Valida configurazione player
 * @param {Object} config - Configurazione da validare
 * @returns {Object} Oggetto con {valid, errors}
 */
export function validateConfig(config) {
  const errors = [];
  
  if (typeof config.skipSeconds === 'number' && (config.skipSeconds < 1 || config.skipSeconds > 120)) {
    errors.push('skipSeconds deve essere tra 1 e 120');
  }
  
  if (config.fftSize && ![32, 64, 128, 256, 512, 1024, 2048].includes(config.fftSize)) {
    errors.push('fftSize deve essere 32, 64, 128, 256, 512, 1024 o 2048');
  }
  
  if (config.shadowMode && !['open', 'closed'].includes(config.shadowMode)) {
    errors.push('shadowMode deve essere "open" o "closed"');
  }
  
  return {
    valid: errors.length === 0,
    errors
  };
}

